import { Add } from "@mui/icons-material";
import { TableCell, TableRow, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import noRolesImg from "../../../assets/images/placeholders/noRolesPlaceholderImg.svg";
import messages from "../../../assets/locale/messages";
import Button from "../../../components/Button";
import EmptyState from "../../../components/EmptyState";
import Pagination from "../../../components/Pagination";
import SearchInput from "../../../components/SearchInput";
import Table from "../../../components/Table";
import TruncateText from "../../../components/TruncateText";
import { rolesListRequest } from "../../../store/Roles/actions";
import { ListDeleteIcon, ListEditIcon } from "../../../utils/Icons";
import { ROUTE_PATHS } from "../../../utils/RoutesPaths";
import { hasPermission, PERMISSIONS_IDS } from "../../../utils/Roles";
import DeleteRole from "../DeleteRole";
import "./RolesList.scss";

const RolesList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [deleteRoleModalOpen, setDeleteRoleModalOpen] =
    useState(false);
  const [deletedRoleDetails, setDeletedRoleDetails] = useState({});
  const lang = useSelector((state) => state.locale.lang);
  const { roles } = messages[lang];
  const isLoading = useSelector((state) => state.loader.showLoader);
  const rolesMeta = useSelector(
    (state) => state.roles.rolesList.meta
  );

  const rolesList = useSelector(
    (state) => state.roles.rolesList.list
  );

  const requestRolesList = () => {
    dispatch(
      rolesListRequest({
        params: {
          page,
          search_value: searchValue
        }
      })
    );
  };
  useEffect(() => {
    requestRolesList();
  }, [page, searchValue]);

  const handleDeleteRole = (name, id) => {
    setDeletedRoleDetails({
      id,
      name,
      src: ROUTE_PATHS.roles,
      params: {
        page,
        search_value: searchValue
      }
    });
    setDeleteRoleModalOpen(true);
  };

  const handleCloseModal = () => {
    setDeleteRoleModalOpen(false);
  };

  const onImageError = (e, initial) => {
    e.target.outerHTML = `
    <div
      class="employee-avatar position-absolute circular-border-radius employee-avatar font-semibold  initial-bg light-brown  inner-white-border circular-border-radius d-flex align-items-center justify-content-center fsize-12 "
    >
      ${initial}
    </div>`;
  };
  const renderRolesTableRow = ({
    Name,
    Id,
    Employees,
    RemainingEmployeesCount,
    IsSuperAdmin
  }) => {
    return (
      <TableRow
        className="pointer  role-row"
        key={`role-row-${Id}`}
        onClick={() =>
          navigate(ROUTE_PATHS.roleDetails.replace(":id", Id))
        }>
        <TableCell>
          <div className="d-flex align-items-center gap-3">
            <TruncateText text={Name || "__"} />
          </div>
        </TableCell>
        <TableCell>
          <div
            className={`avatar-container d-flex align-items-center justify-content-start position-relative ${
              !hasPermission(PERMISSIONS_IDS.roles_edit) &&
              !hasPermission(PERMISSIONS_IDS.roles_delete) &&
              " no-actions-avatar"
            }`}>
            {Employees?.length
              ? Employees?.map((employee) => (
                  <img
                    className="employee-avatar position-absolute circular-border-radius  inner-white-border circular-border-radius"
                    src={employee?.EmployeeImage || employee.Initial}
                    alt="employee-image"
                    key={employee?.RoleId}
                    onError={(e) =>
                      onImageError(e, employee?.Initial)
                    }
                  />
                ))
              : "__"}

            {RemainingEmployeesCount >= 1 && (
              <span className="remaining-count  position-absolute circular-border-radius employee-avatar font-semibold  grey-bg text-grey inner-white-border circular-border-radius d-flex align-items-center justify-content-center fsize-12 ">
                +{RemainingEmployeesCount}
              </span>
            )}
          </div>
        </TableCell>

        {(hasPermission(PERMISSIONS_IDS.roles_edit) ||
          hasPermission(PERMISSIONS_IDS.roles_delete)) && (
          <TableCell>
            {!IsSuperAdmin && (
              <div className="w-100 d-flex justify-content-end gap-2">
                {hasPermission(PERMISSIONS_IDS.roles_edit) && (
                  <ListEditIcon
                    className={"list-action-icon pointer"}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(
                        ROUTE_PATHS.editRole.replace(":id", Id)
                      );
                    }}
                  />
                )}
                {hasPermission(PERMISSIONS_IDS.roles_delete) && (
                  <ListDeleteIcon
                    className={"list-delete-action-icon pointer"}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteRole(Name, Id);
                    }}
                  />
                )}
              </div>
            )}
          </TableCell>
        )}
      </TableRow>
    );
  };
  return (
    <div className="roles-list-container">
      <div className="page-title pb-4 d-flex justify-content-between align-items-md-center align-items-start">
        <div className="title-count-container d-flex justify-content-center align-items-md-center align-items-start flex-column flex-md-row">
          <div>
            <Typography variant="h5" className="title-color me-1">
              {roles.rolesList.rolesListTitle}
            </Typography>
          </div>
          <div className="block-title text-secondary">
            <Typography>{`(${rolesMeta?.count ? rolesMeta?.count : "0"} ${rolesMeta?.count === 1 ? roles.rolesList.role : roles.rolesList.roles})`}</Typography>
          </div>
        </div>
        {hasPermission(PERMISSIONS_IDS.roles_add) && (
          <div className="title-buttons-container d-flex gap-sm-3 gap-1 align-items-center">
            <Button
              label={
                <span className="d-flex align-items-center">
                  <Add fontSize="medium" />
                  <span className="ps-1 d-none d-md-block">
                    {roles.rolesList.addMoreRoles}
                  </span>
                </span>
              }
              customSpacing={"px-2 px-md-4"}
              onClick={() => navigate(ROUTE_PATHS.addRole)}
            />
          </div>
        )}
      </div>
      <div className="role-table-container bg-white d-flex flex-column w-100 p-4 pb-0 px-0 border-radius-8">
        <div className="table-header d-flex px-4 align-items-center w-100 mb-4">
          <SearchInput
            name="Rolesearch"
            id="Rolesearch"
            value={searchValue}
            inputClass="border-radius-8"
            inputWrapperClass="search-input-wrapper"
            placeholder={roles.rolesList.searchPlaceholder}
            onChange={(value) => {
              setPage(1);
              setSearchValue(value);
            }}
          />
        </div>
        <div
          className={`table-content roles-table ${
            !hasPermission(PERMISSIONS_IDS.roles_edit) &&
            !hasPermission(PERMISSIONS_IDS.roles_delete) &&
            "no-actions-table"
          }`}>
          <div>
            {rolesList?.length ? (
              <Table
                className={"px-0"}
                headlines={[
                  roles.rolesList.tableHeader.roleName,
                  roles.rolesList.tableHeader.employees,
                  (hasPermission(PERMISSIONS_IDS.roles_edit) ||
                    hasPermission(PERMISSIONS_IDS.roles_delete)) &&
                    roles.rolesList.tableHeader.action
                ]}
                rows={
                  !isLoading &&
                  rolesList &&
                  rolesList?.map((role) => renderRolesTableRow(role))
                }
              />
            ) : (
              <div className="border-top">
                {!isLoading && (
                  <EmptyState
                    subTitle={
                      !!searchValue && !rolesList?.length
                        ? roles.rolesList.noSearchResults
                        : roles.rolesList.noRolesFound
                    }
                    imgSrc={noRolesImg}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <div className="Pagination-container d-flex justify-content-center py-3 mt-2">
          {!isLoading && rolesList.length > 0 && (
            <Pagination
              count={rolesMeta?.pages}
              page={rolesMeta.currentPage || page}
              handleChange={(page) => setPage(page)}
              defaultPage={1}
            />
          )}
        </div>
      </div>
      {deleteRoleModalOpen && (
        <DeleteRole
          open={setDeleteRoleModalOpen}
          closeModal={handleCloseModal}
          roleInfo={deletedRoleDetails}
        />
      )}
    </div>
  );
};

export default RolesList;
